import { HashMap } from '@floori-web-components';
import { Layouts } from '@floori/models';

export const availableLayouts: HashMap<() => Promise<unknown>> = {
    [Layouts.baseAr]: () => import(`@floori-web/layouts/base-ar/src`),
    [Layouts.baseRooms]: () => import(`@floori-web/layouts/base-rooms/src`),
    [Layouts.baseRoom]: () => import(`@floori-web/layouts/base-room/src`),
    [Layouts.notFound]: () => import(`@floori-web/layouts/base-not-found/src`),
    [Layouts.baseLogin]: () => import(`@floori-web/layouts/base-login/src`),
} as const;
